import { Link } from 'react-router-dom';
import './style.scss';

export const GoToMainArrow = () => (
  <Link className='icon-arrow go-to-main-link' to={'/'}>
    <p>Вернуться на главную</p>
  </Link>
);
